import React, { useCallback, useEffect, useState } from "react";
import useHttpHook from "../../../Hooks/HttpHook";
import { EventList, GetMyPromotingEventsApi } from "../../../utils/ApiConstant";
import {
  createObjectForPaginatedResult,
  redirectUnauthorized,
} from "../../../utils/Helper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import Event from "./Event";
import MainPagination from "../../Common/MainPagination";
import EventFilterModal from "./EventFilterForm";
import { useLocation } from "react-router-dom";
import { isHubRoute } from "../../Layout/V2/eventMenuConfig";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const EventsList = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [eventsList, setEventsList] = useState();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const queryUserName = query.get("userName");
  // Event list hub can filter by profile context from social; other hub pages do not.
  const userName =
    location.pathname === "/" && queryUserName
      ? queryUserName
      : isHubRoute(location.pathname)
      ? null
      : queryUserName;

  const getEvents = useCallback(
    async (page = 1) => {
      if (location.pathname === "/promoter/events") {
        const events = await sendRequest(
          GetMyPromotingEventsApi + "?page=" + page,
          { method: "get" }
        );
        if (page === 1) {
          setEventsList(events);
        } else {
          setEventsList((prevState) => {
            return createObjectForPaginatedResult(events, prevState);
          });
        }
      } else if (userName) {
        const events = await sendRequest(
          `${EventList}?userName=${userName}&page=${page}`,
          { method: "post" }
        );
        if (page === 1) {
          setEventsList(events);
        } else {
          setEventsList((prevState) => {
            return createObjectForPaginatedResult(events, prevState);
          });
        }
      } else {
        const events = await sendRequest(`${EventList}?page=${page}`, {
          method: "post",
        });
        if (page === 1) {
          setEventsList(events);
        } else {
          setEventsList((prevState) => {
            return createObjectForPaginatedResult(events, prevState);
          });
        }
      }
    },
    [location.pathname, sendRequest, userName]
  );

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          redirectUnauthorized();
        }
      }
    }
  }, [error]);

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      {eventsList && eventsList.data?.itemsList?.length > 0 ? (
        <MainPagination getEventsMethod={getEvents} MainData={eventsList}>
          <div className="event-cards-grid" role="list">
            {eventsList.data.itemsList?.map(
              (
                {
                  _id,
                  title,
                  eventTiming,
                  category,
                  location,
                  mainimage,
                  wishlist,
                },
                index
              ) => {
                return (
                  <Event
                    key={index}
                    title={title}
                    eventTiming={eventTiming}
                    category={category}
                    location={location}
                    Id={_id}
                    mainimage={mainimage}
                    wishlist={wishlist}
                  />
                );
              }
            )}
          </div>
        </MainPagination>
      ) : (
        <div className="event-empty">
          <i className="bi bi-calendar2-event" aria-hidden="true"></i>
          <p>No events found.</p>
          <span className="d-none">
            <svg
              width="46"
              height="56"
              viewBox="0 0 46 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.95494 11.9465C11.0546 11.9465 11.946 11.0551 11.946 9.95543C11.946 8.85579 11.0546 7.96436 9.95494 7.96436C8.8553 7.96436 7.96387 8.85579 7.96387 9.95543C7.96387 11.0551 8.8553 11.9465 9.95494 11.9465Z"
                fill="#AFAFAF"
              />
              <path
                d="M9.95494 27.875C11.0546 27.875 11.946 26.9835 11.946 25.8839C11.946 24.7843 11.0546 23.8928 9.95494 23.8928C8.8553 23.8928 7.96387 24.7843 7.96387 25.8839C7.96387 26.9835 8.8553 27.875 9.95494 27.875Z"
                fill="#AFAFAF"
              />
              <path
                d="M9.95494 43.8037C11.0546 43.8037 11.946 42.9122 11.946 41.8126C11.946 40.713 11.0546 39.8215 9.95494 39.8215C8.8553 39.8215 7.96387 40.713 7.96387 41.8126C7.96387 42.9122 8.8553 43.8037 9.95494 43.8037Z"
                fill="#AFAFAF"
              />
              <path
                d="M35.8393 0H3.98214C2.92601 0 1.91314 0.419546 1.16634 1.16634C0.419546 1.91314 0 2.92601 0 3.98214V47.7857C0 48.8418 0.419546 49.8547 1.16634 50.6015C1.91314 51.3483 2.92601 51.7679 3.98214 51.7679H23.8929V47.7857H3.98214V35.8393H39.8214V3.98214C39.8214 2.92601 39.4019 1.91314 38.6551 1.16634C37.9083 0.419546 36.8954 0 35.8393 0ZM35.8393 31.8571H3.98214V19.9107H35.8393V31.8571ZM35.8393 15.9286H3.98214V3.98214H35.8393V15.9286Z"
                fill="#AFAFAF"
              />
              <path
                d="M45.7948 42.6289L42.9874 39.8215L37.8305 44.9784L32.6736 39.8215L29.8662 42.6289L35.0231 47.7858L29.8662 52.9427L32.6736 55.7501L37.8305 50.5932L42.9874 55.7501L45.7948 52.9427L40.6379 47.7858L45.7948 42.6289Z"
                fill="#AFAFAF"
              />
            </svg>
            <small>No Event Found</small>
          </span>
        </div>
      )}
      {props.eventsFilter && (
        <EventFilterModal
          eventURL={EventList}
          setEventsList={setEventsList}
          CloseModalHandler={props.CloseModalHandler}
        />
      )}
    </MainComponentWrapper>
  );
};
export default EventsList;
